<template>
    <div class="container">
        <navigation />

        <div class="row">
            <div class="col-12 text-left">
                <a @click="$router.go(-1)" class="btn btn-link btn-back-link">&laquo; Back</a>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h1>Member Profile</h1>
            </div>
        </div>

        <div class="row" v-if="errorMessages.length > 0">
            <div class="col-12">
                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="successMessages.length > 0">
            <div class="col-12">
                <div v-for="success in successMessages" v-bind:key="success">
                    <div class="alert alert-success">
                        {{success}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="profileFetched">
            <div class="col-12">
                <form class="profile-form" v-on:submit="onSubmit">
                    <p class="small">* Indicates a required field</p>

                    <div class="section">
                        <div class="row">
                            <div class="col-12">
                                <h3>Personal Info</h3>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" :class="{ 'is-invalid': profile.firstName === '' }" name="firstName" placeholder="*First Name" v-model="profile.firstName" required />
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" :class="{ 'is-invalid': profile.lastName === '' }" name="lastName" placeholder="*Last Name" v-model="profile.lastName" required />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="email" class="form-control" :class="{ 'is-invalid': profile.userId === '' }" name="userId" placeholder="*Email Address" v-model="profile.userId" required />
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="tel" class="form-control" :class="{ 'is-invalid': profile.phoneNumber[0].number === '' }" name="mobilePhone" placeholder="*Phone" v-model="profile.phoneNumber[0].number" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}|[0-9]{10}" required />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="row birthDateRow">
                                    <div class="col">
                                        <div class="form-group">
                                            <select v-model="birthMonth" name="birthMonth" class="form-control" :class="{ 'is-invalid': birthMonth === '' }" required>
                                                <option value="">*Birth Month</option>
                                                <option value="01">January</option>
                                                <option value="02">February</option>
                                                <option value="03">March</option>
                                                <option value="04">April</option>
                                                <option value="05">May</option>
                                                <option value="06">June</option>
                                                <option value="07">July</option>
                                                <option value="08">August</option>
                                                <option value="09">September</option>
                                                <option value="10">October</option>
                                                <option value="11">November</option>
                                                <option value="12">December</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <select v-model="birthDay" name="birthDay" class="form-control" :class="{ 'is-invalid': birthDay === '' }" required>
                                                <option value="">*Birth Day</option>
                                                <option v-for="(day, index) in getBirthDays" :key="index" :value="day">{{ day }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <select v-model="birthYear" name="birthYear" class="form-control" :class="{ 'is-invalid': birthYear === '' }" required>
                                                <option value="">*Birth Year</option>
                                                <option v-for="(year, index) in getBirthYears" :key="index" :value="year">{{ year }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="section">
                        <div class="row">
                            <div class="col-12">
                                <h3>Address</h3>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="stree1" placeholder="Street Address 1" v-model="profile.address[0].street1" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="street2" placeholder="Street Address 2" v-model="profile.address[0].street2" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" name="city" placeholder="City" v-model="profile.address[0].city" />
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <select v-model="profile.address[0].stateCode" name="stateCode" class="form-control">
                                        <option value="">State</option>
                                        <option value="AL">Alabama</option>
                                        <option value="AK">Alaska</option>
                                        <option value="AZ">Arizona</option>
                                        <option value="AR">Arkansas</option>
                                        <option value="CA">California</option>
                                        <option value="CO">Colorado</option>
                                        <option value="CT">Connecticut</option>
                                        <option value="DE">Delaware</option>
                                        <option value="DC">District Of Columbia</option>
                                        <option value="FL">Florida</option>
                                        <option value="GA">Georgia</option>
                                        <option value="HI">Hawaii</option>
                                        <option value="ID">Idaho</option>
                                        <option value="IL">Illinois</option>
                                        <option value="IN">Indiana</option>
                                        <option value="IA">Iowa</option>
                                        <option value="KS">Kansas</option>
                                        <option value="KY">Kentucky</option>
                                        <option value="LA">Louisiana</option>
                                        <option value="ME">Maine</option>
                                        <option value="MD">Maryland</option>
                                        <option value="MA">Massachusetts</option>
                                        <option value="MI">Michigan</option>
                                        <option value="MN">Minnesota</option>
                                        <option value="MS">Mississippi</option>
                                        <option value="MO">Missouri</option>
                                        <option value="MT">Montana</option>
                                        <option value="NE">Nebraska</option>
                                        <option value="NV">Nevada</option>
                                        <option value="NH">New Hampshire</option>
                                        <option value="NJ">New Jersey</option>
                                        <option value="NM">New Mexico</option>
                                        <option value="NY">New York</option>
                                        <option value="NC">North Carolina</option>
                                        <option value="ND">North Dakota</option>
                                        <option value="OH">Ohio</option>
                                        <option value="OK">Oklahoma</option>
                                        <option value="OR">Oregon</option>
                                        <option value="PA">Pennsylvania</option>
                                        <option value="RI">Rhode Island</option>
                                        <option value="SC">South Carolina</option>
                                        <option value="SD">South Dakota</option>
                                        <option value="TN">Tennessee</option>
                                        <option value="TX">Texas</option>
                                        <option value="UT">Utah</option>
                                        <option value="VT">Vermont</option>
                                        <option value="VA">Virginia</option>
                                        <option value="WA">Washington</option>
                                        <option value="WV">West Virginia</option>
                                        <option value="WI">Wisconsin</option>
                                        <option value="WY">Wyoming</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" :class="{ 'is-invalid': profile.address[0].zipCode === '' }" name="zipCode" placeholder="*Zip Code" v-model="profile.address[0].zipCode" required />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button type="submit" class="btn btn-primary btn-bellstores" :disabled="!isValid">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <div class="spinner-wrapper">
                    <font-awesome-icon :icon="spinnerIcon" class="spinner"></font-awesome-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

export default {
    name: 'Profile',
    dependencies: ['apiService', 'storageService'],
    components: {

    },
    async mounted () {
        const response = await this.apiService.getProfile()

        if (response instanceof APIRequestError || response instanceof APIResponseError) {
            this.errorMessages.push(response.message())
            this.profileFetched = true
            return
        }

        this.profile = response.toObj()
        this.profileFetched = true

        if (this.profile.dateOfBirth) {
            const [year, month, day] = this.profile.dateOfBirth.split('-')
            // months are zero-indexed
            this.profile.dateOfBirth = new Date(year, month - 1, day)
            console.log(month)
            console.log(day)
            console.log(year)
            this.birthMonth = month
            this.birthDay = day
            this.birthYear = year
        }

        if (this.profile.phoneNumber.length === 0) {
            this.profile.phoneNumber[0] = {
                number: '',
                type: 'O',
                category: 'P'
            }
        } else if (this.profile.phoneNumber[0].number.length === 10) {
            this.profile.phoneNumber[0].number = this.profile.phoneNumber[0].number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        }

        if (this.profile.phoneNumber[0].type === null || this.profile.phoneNumber[0].type === undefined || this.profile.phoneNumber[0].type === '') {
            this.profile.phoneNumber[0].type = 'O'
        }

        if (this.profile.phoneNumber[0].category === null || this.profile.phoneNumber[0].category === undefined || this.profile.phoneNumber[0].category === '') {
            this.profile.phoneNumber[0].category = 'O'
        }

        if (this.profile.address.length === 0) {
            this.profile.address[0] = {
                street1: '',
                street2: '',
                city: '',
                stateCode: '',
                zipCode: '',
                type: 'P'
            }
        }

        if (this.profile.address[0].type === null || this.profile.address[0].type === undefined || this.profile.address[0].type === '') {
            this.profile.address[0].type = 'P'
        }

        // some of the fields aren't needed by the update endpoint
        this.profile.userId = this.profile.emailAddress
        const fields = [
            'responseCode',
            'accountNumber',
            'memberId',
            'referralUrl',
            'partSrcId',
            'memberAttributes',
            'status',
            'emailAddress',
            'memberIdStatus',
            'middleName'
        ]

        const that = this
        fields.forEach(function (field) {
            delete that.profile[field]
        })

        console.log(response)
    },
    data () {
        return {
            profile: {
                address: [{
                    zipCode: ''
                }],
                phoneNumber: [{
                    number: ''
                }],
                firstName: '',
                lastName: '',
                userId: ''
            },
            birthMonth: '',
            birthDay: '',
            birthYear: '',
            errorMessages: [],
            successMessages: [],
            profileFetched: false
        }
    },
    computed: {
        isValid () {
            return this.profile.firstName !== '' &&
                this.profile.lastName !== '' &&
                this.profile.userId !== '' &&
                this.profile.phoneNumber[0].number !== '' &&
                this.profile.birthMonth !== '' &&
                this.profile.birthDay !== '' &&
                this.profile.birthYear !== '' &&
                this.profile.address[0].zipCode !== ''
        },
        spinnerIcon () {
            return faSpinner
        },
        getBirthDays () {
            const birthDays = []
            let i

            for (i = 1; i <= 31; i++) {
                birthDays.push(('0' + i).slice(-2))
            }

            return birthDays
        },
        getBirthYears () {
            const birthYears = []
            let i
            const d = new Date()
            const year = d.getFullYear()

            for (i = 0; i <= 120; i++) {
                birthYears.push(year - i)
            }

            return birthYears
        }
    },
    methods: {
        async onSubmit (e) {
            e.preventDefault()
            this.errorMessages = []
            this.successMessages = []

            this.profile.dateOfBirth = new Date(this.birthYear, this.birthMonth - 1, this.birthDay)

            const response = await this.apiService.updateProfile(this.profile)

            if (response instanceof APIRequestError || response instanceof APIResponseError) {
                this.errorMessages.push(response.message())
                return
            }

            console.log(response)
            this.successMessages.push('Your profile has been updated')
        }
    }
}
</script>

<style scoped lang="scss">
    .section {
        margin-bottom: 30px;
    }

    .spinner-wrapper {
        margin-top: 20px;

        .fa-spinner {
            width: 50px;
            height: 50px;
        }
    }

    .birthDateRow {
        margin-left: -2.5px;
        margin-right: -2.5px;

        .col {
            padding-left: 2.5px;
            padding-right: 2.5px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue